/* eslint-disable @typescript-eslint/no-unused-vars */
import { createContext } from 'react';
import dayjs from 'dayjs';

import {
  HierarchicalBulkTimeEntry,
  TaskTimeEntryItem,
  TimeEntryCommon,
  TimeEntryItem,
} from '@totem/components/ticketing/details/timeEntry/bulkTimeEntry/types';

interface BulkTimeEntryContextProps {
  taskTimeEntryHierarchy: HierarchicalBulkTimeEntry[];
  taskTimeItems: TaskTimeEntryItem[];
  timeEntryCommon: TimeEntryCommon;
  onUpdateTaskHours: (taskId: string, newHours: number) => void;
  onUpdateTaskBillable: (taskId: string, newBillable: boolean) => void;
  onUpdateAllTaskBillable: (newBillable: boolean) => void;
  onUpdateTaskDescription: (taskId: string, newDescription: string) => void;
  getTimeEntry: (taskId: string) => TimeEntryItem;
  setTimeEntryCommon: (newCommon: TimeEntryCommon) => void;
}

export default createContext<BulkTimeEntryContextProps>({
  taskTimeEntryHierarchy: [],
  taskTimeItems: [],
  timeEntryCommon: {
    resourceId: '',
    date: dayjs().toISOString(),
    billable: false,
  },
  onUpdateTaskHours: (taskId: string, newHours: number) => {},
  onUpdateTaskBillable: (taskId: string, newBillable: boolean) => {},
  onUpdateAllTaskBillable: (newBillable: boolean) => {},
  onUpdateTaskDescription: (taskId: string, newDescription: string) => {},
  getTimeEntry: (taskId: string) => {
    return null;
  },
  setTimeEntryCommon: (newCommon: TimeEntryCommon) => {},
});
